import { IconProps, Icon } from "@chakra-ui/react";

function PlusIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.99996 4.66667V16.3333M4.16663 10.5H15.8333"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}

export default PlusIcon;
